// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__-LSZp","colBig":"styles_colBig__1HU1w","colSmall":"styles_colSmall__38z8e","shopifyNameWrapper":"styles_shopifyNameWrapper__3VH8f"};